import {useCallback, useEffect, useRef, useState} from 'react'

import useWindowSize from '../useWindowSize'

export default function Tooltip (props) {
  const { width: windowWidth } = useWindowSize()
  const [offset, setOffset] = useState(0)
  const ref = useRef()

  const updatePosition = useCallback(() => {
    if (!ref.current || !windowWidth) return 'none'
    const left = ref.current.getBoundingClientRect().x
    const right = left + ref.current.getBoundingClientRect().width

    if (windowWidth - right < 125) {
      setOffset(-1 * (right - windowWidth + 125))
    } else if (left < 125) {
      setOffset(125 - left)
    } else {
      setOffset(0)
    }
  }, [windowWidth])

  useEffect(() => {
    updatePosition()
  }, [windowWidth])

  return (
    <div
      className="wp-block-gds-lead-form__tooltip"
      ref={ref}
      onMouseEnter={updatePosition}
    >
      <img src="/app/themes/gds/public/icons/solid/circle-info.svg" />
      <div
        className="wp-block-gds-lead-form__tooltip__content"
        style={{
          transform: `translateX(calc(-50% + 7.5px + ${offset || 0}px))`
        }}
      >
        {props.children}
      </div>
    </div>
  )
}